module.exports = __webpack_public_path__ + "static/media/about_inner_misson.06e6cb73.png";